exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wf_checkbox {\n  padding: 6px 0px;\n}\n.wf_checkbox .label {\n  color: #1C1C1C !important;\n}\n.wf_checkbox:focus .ant-checkbox {\n  border: 0.125rem solid #E60023;\n  padding: 0.031rem;\n}\n.wf_checkbox:focus .ant-checkbox .ant-checkbox-inner {\n  border-radius: 0;\n}\n", ""]);

